import styled from 'styled-components';

export const PoolsContainer = styled.div`
	display: flex;
	gap: 24px;
	flex-wrap: nowrap;
	overflow-x: auto;
	overflow-y: hidden;
	padding-bottom: 8px;
	scroll-behavior: smooth;

	/* Custom scrollbar styling */
	&::-webkit-scrollbar {
		height: 6px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}
`;

export const PoolCard = styled.div`
	border: 1.5px solid #e5e5e5;
	border-radius: 14px;
	padding: 20px;
	min-width: 260px;
	max-width: 320px;
	width: 280px;
	flex-shrink: 0;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	transition: box-shadow 0.2s, border-color 0.2s;
	cursor: pointer;
	margin-bottom: 12px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: flex-start;
	min-height: 180px;
	height: 180px;
	justify-content: flex-start;
	&:hover {
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
		border-color: #e5e5e5;
	}
`;

export const PoolName = styled.div`
	font-weight: 700;
	font-size: 20px;
	color: #222;
	margin-bottom: 2px;
`;

export const PoolDescription = styled.div`
	font-size: 13px;
	color: #888;
	margin-bottom: 6px;
	opacity: 0.9;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
	max-height: 2.8em;
`;

export const PoolInfoRow = styled.div`
	font-size: 14px;
	color: #222;
	margin-bottom: 2px;
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const PoolInfoLabel = styled.span`
	font-weight: 600;
	color: #222;
`;

export const PoolInfoValue = styled.span`
	color: #444;
	font-size: 13px;
	margin-top: 8px;
	min-height: 18px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
	max-height: 2.8em;
`;
